import { useTranslation } from 'react-i18next';

import { NgButton } from '../buttons/NgButton';
import type { ButtonType, ComponentSize } from '../types';

export type LoadingRetryButtonProps = {
  onRetry: () => void | Promise<void>;
  size?: ComponentSize;
  type?: ButtonType;
};

export function LoadingRetryButton({ onRetry, size, type }: LoadingRetryButtonProps) {
  const { t } = useTranslation();

  return (
    <NgButton
      text={t('Button_TryAgain')}
      icon="fal fa-rotate-right"
      size={size}
      type={type}
      showProgress
      enableMultipleClickPrevention
      onClick={() => onRetry()}
    />
  );
}
